export default () => {
  return new Promise(async (resolve) => {
    try {
      $.getJSON('/cart.js', (json) => {
        window.theme.cart.data = json;
        resolve(json);
      });
    } catch (err) {
      console.log('Cannot retrieve the cart data', err);
      resolve(null);
    }
  });
};
